import className from "~/kernel/styling/className";
import Footer from "./Footer";
import type { ContainerSize } from "./Container";
import Container from "./Container";
import NavigationBar from "./NavigationBar";
import Breadcrumb from "~/ui/Breadcrumb";
import WaitForTranslations from "~/kernel/internationalization/WaitForTranslations";
import type useLinks from "~/ui/useLinks";

const bgColorClasses = {
  slate: "bg-slate-50",
  white: "bg-white",
};

type DefaultLayoutProps = {
  children: React.ReactNode;
  backgroundColor?: keyof typeof bgColorClasses;
  containerSize?: ContainerSize;
  breadcrumb?: Parameters<typeof Breadcrumb>[0]["links"];
  links?: ReturnType<typeof useLinks>;
};

export default function DefaultLayout({
  children,
  backgroundColor = "slate",
  containerSize = "medium",
  breadcrumb: breadcrumbProps,
  links = undefined,
}: DefaultLayoutProps) {
  return (
    <WaitForTranslations>
      <div
        className={className(
          "flex h-full min-h-screen flex-col space-y-8",
          bgColorClasses[backgroundColor],
        )}
      >
        <NavigationBar links={links} />
        <div className="flex-1">
          <Container size={containerSize}>
            <div className="space-y-2">
              {breadcrumbProps && <Breadcrumb links={breadcrumbProps} />}
              {children}
            </div>
            <footer className="h-20" />
          </Container>
        </div>
        <Footer />
      </div>
    </WaitForTranslations>
  );
}
